<template>
  <div class="fields">
    <ToolTitle :title="form.name" :menu="true" :menuby="'form'" />
    <ToolLoading v-if="!isloaded" />
    <div v-if="isloaded" class="fields__tool">
      <draggable class="fields__tool__form" v-model="form.fields" group="people">
        <div
          class="-draggable"
          v-for="(item, index) in form.fields"
          :key="index"
          :is="`${item.type}`"
          v-model="item.options"
        >
          <span class="remove" @click="remove(index)">
            <IconClear />
          </span>
        </div>
      </draggable>
      <draggable class="fields__tool__inputs" v-model="fields" group="people">
        <div class="-draggable" v-for="(item, index) in fields" :key="index">{{item.title}} Ekle</div>
      </draggable>
    </div>
    <FormButton
      :isFieldPage="true"
      v-if="isloaded"
      @action="update()"
      :text="'Kaydet'"
      :status="status"
    />
  </div>
</template>

<script>
import * as API from "@/services/";
import * as Helpers from "@/helpers/";
import { fields } from "./fields";
import draggable from "vuedraggable";
import Input from "./Input.vue";
import Eposta from "./Eposta.vue";
import Checkbox from "./Checkbox.vue";
import Dropdown from "./Dropdown.vue";
import Textarea from "./Textarea.vue";

export default {
  components: { draggable, Input, Checkbox, Eposta, Dropdown, Textarea },
  data() {
    return {
      isloaded: false,
      status: {
        loading: false,
        message: "",
        type: ""
      },
      form: {},
      fields: fields()
    };
  },
  created() {
    this.init();
  },
  watch: {
    fields: function(val) {
      if (val.length == 4) return;
      this.fields = Helpers.deepCopy(fields());
    }
  },
  methods: {
    init: async function() {
      let vm = this;

      await API.getForm(vm.$route.params.company, vm.$route.params.form).then(
        response => (vm.form = response.result)
      );
      vm.isloaded = true;
    },
    update: async function() {
      let vm = this;

      vm.status.loading = true;
      vm.status.type = "";
      vm.status.message = "Form düzenleniyor...";

      vm.form.updated = {
        by: vm.$store.getters.getUser,
        date: await Helpers.currentDateTime()
      };

      await API.updateForm(vm.form)
        .then(async response => {
          vm.status.type = "success";
          if (response.status.code != 200) vm.status.type = "Error";
          vm.status.message = response.status.message;

          vm.form = response.result;
        })
        .catch(error => {
          vm.status.type = "Error";
          vm.status.message = error;
        });

      vm.status.loading = false;
    },
    remove: function(indx) {
      this.form.fields.splice(indx, 1);
    }
  }
};
</script>
